/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceDesktopBolt = createReactComponent("outline", "device-desktop-bolt", "IconDeviceDesktopBolt", [["path", { "d": "M14.5 16h-10.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M7 20h6", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

export { IconDeviceDesktopBolt as default };
//# sourceMappingURL=IconDeviceDesktopBolt.mjs.map
